import { render, staticRenderFns } from "./AccettazioneSsnStrutturaPresidioComponent.vue?vue&type=template&id=5fd6a23f&scoped=true"
import script from "./AccettazioneSsnStrutturaPresidioComponent.vue?vue&type=script&lang=js"
export * from "./AccettazioneSsnStrutturaPresidioComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd6a23f",
  null
  
)

export default component.exports